export const ScheduleCommentaryCategory = Object.freeze({
    CORE: "core",
    SPECIALIST_SERVICES: "specialist-services",
    FUNCTIONAL_SETS: "functional-sets",
    NEW: "new",
})
